<template>
  <div class="gold_main">
    <div class="gold_banner">
      <img src="../../assets/images/img2/gold_banner.png" alt="" />
    </div>
    <div class="con">
      <div class="index_mod1top">
        <div class="index_mod1text">
          <p class="index_mo1tit1">充值享优惠</p>
          <p class="index_mo1tit2">充值钜惠不停狂欢继续</p>
        </div>
        <div class="index_mod1bg"></div>
      </div>
      <div class="gold_list">
        <div class="gold_li" v-for="(item, index) in jblist" :key="index" @click="payGold(item)">
          <img src="../../assets/images/img2/gold_bg1.png" v-if="index == 0" />
          <img src="../../assets/images/img2/gold_bg2.png" v-if="index == 1" />
          <img src="../../assets/images/img2/gold_bg3.png" v-if="index == 2" />
          <img src="../../assets/images/img2/gold_bg4.png" v-if="index == 3" />
          <img src="../../assets/images/img2/gold_bg5.png" v-if="index == 4" />
          <img src="../../assets/images/img2/gold_bg6.png" v-if="index == 5" />
          <div class="gold_con">
            <p>
              <span class="gold_num">{{ item.jb }}</span
              ><span class="gold_unit">金币</span>
            </p>
            <p class="gold_litext">1元 = 10金币</p>
            <p class="gold_litext">金币可用于作品导出</p>
            <div class="gold_libtn">立即充值</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pay_gold" v-if="show_pay">
      <!-- <div class="pay_goldmg" ></div> -->
      <div class="pay_goldcon">
        <p style="font-size: 18px; font-weight: bold; text-align: center">
          {{item.jb}}金币
        </p>
        <p style="font-size: 12px; color: #666; text-align: center">
          {{ initData() }}
        </p>
        <img class="pos" src="../../assets/images/img2/offlogin.png" alt="" @click="hidePay">
        <p
          style="
            width: 384px;
            height: 1px;
            border: 1px solid #eeeeee;
            margin: 20px auto;
          "
        ></p>
        <div class="gold_code" v-loading="loading">
          <img :src="code_url" v-show="code_url" />
        </div>
        <p style="text-align: center;">微信支付</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["jblist"]),
  },
  data() {
    return {
      show_pay: false, // 支付界面显示状态
      code_url: "", // 支付二维码图片地址
      crgid: "", // 支付id
      loading: false, //支付加载动话显示状态
      item:'',//当前支付选项
      paytime:null,//支付检查计时器
    };
  },
  destroyed() {
    clearInterval(this.paytime);
  },
  watch: {
    $route(to, from) {
       clearInterval(this.paytime);
    },
  },
  mounted() {},
  methods: {
    //显示日期在页面上
    initData() {
      var date = new Date();
      //年
      var year = date.getFullYear();
      //月
      var month = date.getMonth() + 1;
      //日
      var day = date.getDate();
      //时
      var hh = date.getHours();
      //分
      var mm = date.getMinutes();
      //秒
      var ss = date.getSeconds();
      var rq = year + "年" + month + "月" + day + "日" + hh + ":" + mm;
      return rq;
    },
    // 购买金币
    payGold(item) {
      this.item = item
      this.show_pay = true;
      let self = this;
      let json = {
        crgtype: 1,
        paytype: 2,
        ordername: "金币充值",
        jb: item.jb,
        rmb: item.rmb,
        ish5: 4,
      };
      let url =
        self.$store.state.base_api + self.$store.state.base_url.cashorder;
      this.code_url = "";
      this.loading = true;
      this.$request.postHttp(json, url, (response) => {
        console.log(response);
        self.code_url = response.model.orderparams4webchat.code_url;
        self.crgid = response.model.crgid;
        self.loading = false;
        self.verifyPay()
      });
    },
    // 隐藏支付
    hidePay() {
      this.show_pay = false;
      clearInterval(this.paytime);
    },
    // 验证支付
    verifyPay() {
      let self = this;
      clearInterval(self.paytime);
      this.paytime = setInterval(() => {
        if (self.crgid == "") return;
        let url =
          self.$store.state.base_api + self.$store.state.base_url.qryorderinfo;
        let json = {
          crgid: self.crgid,
        };
        self.$request.postHttp(json, url, (decdata) => {
          if (decdata.model.status !== "1") return;
          //支付成功清除计时器
          clearInterval(self.paytime);
          self.show_pay = false;
          self.$globalFun.getUserInfo(self);
          self.$alert("充值成功！", "提示", {
            confirmButtonText: "确定",
          });
        });
      }, 3000);
    },
  },
};
</script>
<style>
@import url("../../assets/css/gold.css");
</style>


// WEBPACK FOOTER //
// src/view/recharge/gold.vue